import PrivacyPolicy from "@/pages/privacyPolicy";
import { createPublicSsrPage } from "../../src/vike/createPublicSsrPage";
import { PATHS } from "../../src/shared/publicPaths";

export default createPublicSsrPage({
  pathname: PATHS.privacy,
  overrideKey: "privacyPolicy",
  element: <PrivacyPolicy />,
});
